import { environment } from './environment';

export interface LumirProduct {
  /** Stable key a surface passes as its own identity to the switcher. */
  id: 'fotoclass' | 'photobook' | 'gallery' | 'studio-manager';
  /** Product name as the switcher row shows it — and the second word of that shell's wordmark. */
  label: string;
  /** One line under the name in the switcher: what the surface is for. */
  role: string;
  /** Absolute origin — surfaces live on separate hosts, so a route would never reach a sibling. */
  url: string;
  /** Product still in beta: the switcher marks its row and its wordmark with the «beta» pill. */
  beta?: boolean;
}

/**
 * The list of product surfaces a signed-in user can move between. One source for every shell:
 * a per-shell copy would drift the moment a third surface joins. The array order IS the menu order —
 * the switcher renders the rows as they stand here.
 */
export const LUMIR_PRODUCTS: readonly LumirProduct[] = [
  { id: 'fotoclass', label: 'Альбомы', role: 'Школы и сады', url: environment.FOTOCLASS_ENDPOINT },
  { id: 'photobook', label: 'Фотокниги', role: 'Дизайн фотокниг', url: environment.PHOTOBOOK_ENDPOINT, beta: true },
  {
    id: 'studio-manager',
    label: 'Маркетинг',
    role: 'CRM, клиенты и продажи',
    url: environment.STUDIO_MANAGER_APP_URL,
    beta: true,
  },
  { id: 'gallery', label: 'Галереи', role: 'Красивая передача съёмок', url: environment.GALLERY_APP_URL, beta: true },
];
